export default "__VITE_ASSET__6cc7a386__"